function openContent(accordiontabs, index) {

    let actIndex = index;

    accordiontabs.querySelectorAll('[data-head-index]').forEach(function (head) {
        head.removeAttribute('class');
        if (index == head.getAttribute('data-head-index') && index != accordiontabs.getAttribute('data-index')) {
            head.className = 'act';
        }
    });

    accordiontabs.querySelectorAll('[data-content-index]').forEach(function (content) {
        let contentHeight = 0;

        if (index == content.getAttribute('data-content-index')) {
            contentHeight = parseInt(getComputedStyle(content.firstElementChild)['height']);
            contentHeight += parseInt(getComputedStyle(content.firstElementChild)['padding-top']);
            contentHeight += parseInt(getComputedStyle(content.firstElementChild)['padding-bottom']);
        }
        if (index == accordiontabs.getAttribute('data-index')) {
            contentHeight = 0;
        }
        content.style.maxHeight = contentHeight + 'px';
    });


    if (index == accordiontabs.getAttribute('data-index')) {
        actIndex = -1;
    }

    accordiontabs.setAttribute('data-index', actIndex);

}

if (document.querySelectorAll('.ag_accordion')) {
    document.querySelectorAll('.ag_accordion').forEach(function (accordiontabs) {

        accordiontabs.querySelectorAll('[data-head-index]').forEach(function (head) {
            head.addEventListener('click', function () {
                openContent(accordiontabs, head.getAttribute('data-head-index'));
            });
        });

    });

    document.querySelectorAll('.ag_accordion [data-openfirst]').forEach(function (accordiontabs) {
        accordiontabs.querySelector('[data-head-index="0"]').click();
    });
}
